import { Grid, styled, Typography } from '@mui/material';

export const StyledInformationBox = styled(Grid)(
  ({ theme }) => `
      padding: 10px 20px;
      background-color: ${theme.palette.brand.whitesmoke};
      border-radius: 5px;
    `,
);

export const StyledInformationBoxText = styled(Typography)(
  ({ theme }) => `
      font-family: Roboto;
      font-size: 14px;
      font-weight: 300;
      line-height: 16px;
      color: ${theme.palette.brand.charcoal};
    `,
);
